import {createSelector} from 'reselect';
import SessionType from '../../enums/SessionType';

const getSessionType = state => state.start.sessionType;

const getTranslationBase = createSelector(
  getSessionType,
  (sessionType) => {
    switch (sessionType) {
      case SessionType.PAYMENT_CHANGE:
      case SessionType.PAYMENT_RESOLUTION: // Intentional fallthrough
        return 'messages.paymentResolutionOrderProcessing.';
      default:
        return 'messages.orderProcessing.';
    }
  },
);

export const getTitleKey = createSelector(
  getTranslationBase,
  translationBase => `${translationBase}title`,
);

export const getContentKey = createSelector(
  getTranslationBase,
  translationBase => `${translationBase}content`,
);

export const getErrorRedirect = createSelector(
  getSessionType,
  (sessionType) => {
    const errorRedirect = {
      [SessionType.PAYMENT_RESOLUTION]: '/payment-resolution',
      [SessionType.PAYMENT_CHANGE]: '/payment-change',
    };
    
    return `/checkout${errorRedirect[sessionType] || '/'}?error=true`;
  },
);

export const getSuccessRedirect = createSelector(
  getSessionType,
  (sessionType) => {
    const successRedirect = {
      [SessionType.PAYMENT_RESOLUTION]: '/payment-resolved',
      [SessionType.PAYMENT_CHANGE]: '/payment-changed',
    };
    
    return `/checkout${successRedirect[sessionType] || '/complete'}`;
  },
);
